export enum FEATURE_FLAGS {
	NEW_NAVIGATION_BAR_ENABLED = 'newNavigationBarEnabled',
	NEW_WE_NETWORK_PAGE_ENABLED = 'newWENetworkPageEnabled',
	SHOW_OCR_EXCEPTION = 'showOcrException',
	ONE_TRUST_COOKIE_BANNER_ENABLED = 'oneTrustCookieBannerEnabled',
	SHOW_PARTICIPANT_PROFILE_EDIT_MODE = 'showParticipantProfileEditMode',
	NOTIFICATIONS_ENABLED = 'notificationsEnabled',
	NOTIFICATIONS_POLLING_ENABLED = 'notificationsPollingEnabled',
	NOTIFICATIONS_POLLING_TIME = 'notificationsPollingTime',
	NEW_IA_FEATURE_CLIENT_IDS = 'newIAFeatureClientIds',
	PROJECT_X_ENABLED = 'projectXEnabled',
	DISABLE_LANDING_PAGE_CLIENT_IDS = 'disableLandingPageClientIds',
	NEW_TUITION_PROFILE_PAGE_CLIENT_IDS = 'newTuitionProfileClientIds',
	NEW_TUITION_BENEFITS_AND_SUPPORT_PAGE_CLIENT_IDS = 'newBenefitAndSupportClientIds',
	GROWTHBOOK_CLIENT_KEY = 'growthBookClientKey',
	ENABLE_PRINT_FEATURE = 'enablePrintFeature',
	NEW_LOGIN_UI_ENABLED = 'newLoginUIClientIds'
}
